import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router, UrlTree } from '@angular/router';
import { AuthService } from './auth.service';
import { AuthSessionService } from './auth-session.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuardService  {
  currentUrl: string = undefined;

  constructor(
    private authService: AuthService,
    private router: Router,
    private authSession: AuthSessionService,
  ) { 
    
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    this.currentUrl = this.router.url;
    const currentUrl = state.url;

    if (this.authSession.isForcedPasswordChange()) {
      return this.router.createUrlTree(['/change-password'], {
        queryParams: this.authSession.forcedPasswordChangeQueryParams(),
      });
    }

    if (
      AuthSessionService.isSecondScreenChild() &&
      currentUrl.includes('/digital-signature-manual')
    ) {
      return true;
    }
    if (sessionStorage.getItem('forcedLogoutByExtension') === '1') {
      this.router.navigate(['/login']);
      return false;
    }
    if (!this.authSession.isSessionActive()) {
      this.authService.forceLogout('-2');
      return false;
    }
    const screenId = route.data['screenId'];
    localStorage.setItem('screenId',screenId);
    if (screenId == '-1') {
      return true;
    }
    if (currentUrl.includes('/digital-signature-manual')) {
      return true;
    }
    if (currentUrl.includes('/approve-page')) {
      return true;
    }
    if (this.authService.hasPermission(screenId)) {
      return true;
    } else {
      return false;
    }
  }
}
